import tinycolor from "tinycolor2";
import React from 'react';


export const AffiliationView = ({ affiliations }) => {

  return <>
    {
      affiliations.map(({name, color}, i) => {
	const tcolor = tinycolor(color);
	const style = {color: tcolor.clone().darken(30), backgroundColor: tcolor.clone().brighten(40)};
	return <div key={i} style={style}>{ name }</div>
      })
    }
  </>
}
